import withDraft from '@/utils/draftHelper';
import findResult, { assignIfExists } from '@/utils/resultsHelper';
import { findAllDatasets } from './shared';
import dataModelsActions from '../datamodels/constants';

const updateDatasetDataModel = withDraft((draft, { code, result }) => {
  findAllDatasets(draft, { items: [{ code }] }).forEach((category) => {
    const item = findResult(draft.datasets, category, code);
    assignIfExists(item, { data_model: result });
  });
});

export default {
  [dataModelsActions.UPDATE_DATASET_DATA_MODEL_SUCCESS]: updateDatasetDataModel,
};
